import * as types from "./actiontypes"

const initialState = {
    clientData: null,
    isLoading: false,
    isError: false
}

export const Clientreducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_CLIENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.GET_CLIENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                clientData: payload
            }

        case types.GET_CLIENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                // massage: ""
            }

        case types.CREATE_CLIENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.CREATE_CLIENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                clientData: payload
            }

        case types.CREATE_CLIENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            }

        default:
            return state
    }
}